/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'exclamation': {
    width: 3,
    height: 11,
    viewBox: '0 0 3 11',
    data: '<path pid="0" d="M.705 7.536L.13.27l2.265.015-.574 7.25H.705zm-.47 1.088h2.058v2.03H.234v-2.03z" _fill="#404040" fill-rule="nonzero"/>'
  }
})
